import { Icon } from '@purpur/library/icon';
import styled, { css } from 'styled-components';

import { defaultLinkStyle, purpurFocus } from '@telialt/common-theme/src/mixins';
import { getPurpurColor, getPurpurSpacing, getPurpurTypography } from '@telialt/common-theme/src/purpurSelectors';
import { NavigationItem } from '@telialt/models/src/Navigation';

import { displayOption } from '../Navigation.styles';

export const MenuItemIcon = styled(Icon)`
    && {
        height: 1rem;
        min-width: 1rem;
        width: 1rem;
    }

    svg {
        vertical-align: top;
    }
`;

export const MenuItemBase = styled.div<{
    $isActive?: boolean;
    $isActiveUnderline?: boolean;
    $displayOption?: NavigationItem['displayOption'];
    $colorOption?: NavigationItem['colorOption'];
}>`
    ${defaultLinkStyle()};
    align-items: center;
    position: relative;
    font-weight: ${getPurpurTypography('weightMedium')};
    font-size: ${getPurpurTypography('scale100')};
    font-weight: ${({ $colorOption }) =>
        $colorOption ? getPurpurTypography('weightBold') : getPurpurTypography('weightMedium')};
    color: ${({ $colorOption }) => {
        if ($colorOption === 'red') {
            return getPurpurColor('red500');
        }

        return getPurpurColor('textInteractivePrimaryActive');
    }};
    padding: 0 ${getPurpurSpacing('50')};
    cursor: pointer;
    height: 100%;
    display: flex;
    text-decoration: none;
    border-top: 2px solid transparent;
    border-bottom: 2px solid transparent;
    gap: ${getPurpurSpacing('100')};

    ${({ $isActive }) =>
        $isActive &&
        css`
            color: ${getPurpurColor('purple500')};
            border-bottom-color: ${getPurpurColor('purple500')};
        `};

    ${({ $displayOption }) => displayOption($displayOption)};

    &:hover {
        color: ${getPurpurColor('textInteractivePrimaryHover')};
        border-bottom-color: ${getPurpurColor('textInteractivePrimaryHover')};
    }

    ${purpurFocus()};
`;

export const StyledMenuItem = styled(MenuItemBase).attrs({ as: 'a' })``;
export const StyledMenuComponentBase = styled(MenuItemBase)``;
